export default __webpack_public_path__ + "static/media/circles-anim.f512ffe5.svg";